/* Masina Creative — scroll progress for pinned image breaks.
   Sets --mc-progress (0 → 1) on each [data-mc-scroll] section as it
   travels through the viewport, so CSS can deepen a scrim as you scroll.
   Purposeful, subtle, and disabled when the user prefers reduced motion. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var sections = Array.prototype.slice.call(
    document.querySelectorAll('[data-mc-scroll]')
  );
  if (!sections.length) return;

  var ticking = false;

  function update() {
    ticking = false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    sections.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      // 0 when the section's top reaches the viewport top,
      // 1 when its bottom reaches the viewport bottom.
      var total = rect.height - vh;
      var progress = total > 0 ? (-rect.top) / total : 0;
      progress = Math.min(1, Math.max(0, progress));
      el.style.setProperty('--mc-progress', progress.toFixed(3));
    });
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();

/* ---- Hero fallback slideshow ---------------------------------------
   Gently cross-fades through the texture photos behind the hero video.
   Skipped entirely when the user prefers reduced motion. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var holders = document.querySelectorAll('[data-mc-hero-slides]');
  Array.prototype.forEach.call(holders, function (holder) {
    var slides = holder.querySelectorAll('.mc-hero__slide');
    if (slides.length < 2) return;
    var interval = parseInt(holder.getAttribute('data-mc-hero-interval'), 10) || 7000;
    var i = 0;
    setInterval(function () {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, interval);
  });
})();

/* ---- Header: solid-on-scroll + mobile menu -------------------------- */
(function () {
  var header = document.querySelector('[data-mc-header]');
  if (!header) return;

  // Solid bar once scrolled past the hero (overlay mode only).
  if (header.hasAttribute('data-mc-overlay')) {
    var solidify = function () {
      var threshold = (window.innerHeight || 800) * 0.82;
      header.classList.toggle('is-solid', window.pageYOffset > threshold);
    };
    window.addEventListener('scroll', solidify, { passive: true });
    window.addEventListener('resize', solidify, { passive: true });
    solidify();
  }

  // Mobile menu toggle.
  var toggle = header.querySelector('[data-mc-nav-toggle]');
  var nav = header.querySelector('[data-mc-nav]');
  if (toggle && nav) {
    var label = toggle.querySelector('.mc-header__toggle-label');
    var setOpen = function (open) {
      nav.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (label) label.textContent = open ? 'Close' : 'Menu';
    };
    toggle.addEventListener('click', function () {
      setOpen(!nav.classList.contains('is-open'));
    });
    // Close after tapping a link.
    nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) setOpen(false);
    });
  }
})();

/* ---- Lightbox -------------------------------------------------------
   Click any [data-mc-lightbox] to view it large; step through others in
   the same [data-mc-group]. Keyboard: Esc closes, ← → navigate. No
   library, minimal motion. */
(function () {
  var triggers = Array.prototype.slice.call(
    document.querySelectorAll('a[data-mc-lightbox]')
  );
  if (!triggers.length) return;

  var current = [];
  var index = 0;

  // Build overlay once.
  var box = document.createElement('div');
  box.className = 'mc-lightbox';
  box.setAttribute('role', 'dialog');
  box.setAttribute('aria-modal', 'true');
  box.innerHTML =
    '<button class="mc-lightbox__btn mc-lightbox__close" aria-label="Close">×</button>' +
    '<button class="mc-lightbox__btn mc-lightbox__prev" aria-label="Previous">‹</button>' +
    '<img class="mc-lightbox__img" alt="">' +
    '<button class="mc-lightbox__btn mc-lightbox__next" aria-label="Next">›</button>' +
    '<p class="mc-lightbox__caption"></p>';
  document.body.appendChild(box);

  var imgEl = box.querySelector('.mc-lightbox__img');
  var capEl = box.querySelector('.mc-lightbox__caption');
  var prevBtn = box.querySelector('.mc-lightbox__prev');
  var nextBtn = box.querySelector('.mc-lightbox__next');
  var closeBtn = box.querySelector('.mc-lightbox__close');
  var lastFocus = null;

  function render() {
    var t = current[index];
    if (!t) return;
    imgEl.src = t.getAttribute('href');
    imgEl.alt = (t.querySelector('img') && t.querySelector('img').alt) || '';
    var cap = t.getAttribute('data-mc-caption') || '';
    capEl.textContent = cap;
    capEl.style.display = cap ? '' : 'none';
    var many = current.length > 1;
    prevBtn.style.display = many ? '' : 'none';
    nextBtn.style.display = many ? '' : 'none';
  }
  function open(trigger) {
    var group = trigger.getAttribute('data-mc-group') || '';
    current = triggers.filter(function (t) {
      return (t.getAttribute('data-mc-group') || '') === group;
    });
    index = current.indexOf(trigger);
    if (index < 0) { current = [trigger]; index = 0; }
    lastFocus = document.activeElement;
    render();
    box.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }
  function close() {
    box.classList.remove('is-open');
    document.body.style.overflow = '';
    imgEl.src = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function step(d) {
    if (!current.length) return;
    index = (index + d + current.length) % current.length;
    render();
  }

  triggers.forEach(function (t) {
    t.addEventListener('click', function (e) {
      e.preventDefault();
      open(t);
    });
  });
  closeBtn.addEventListener('click', close);
  prevBtn.addEventListener('click', function () { step(-1); });
  nextBtn.addEventListener('click', function () { step(1); });
  box.addEventListener('click', function (e) {
    if (e.target === box) close();
  });
  document.addEventListener('keydown', function (e) {
    if (!box.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') step(-1);
    else if (e.key === 'ArrowRight') step(1);
  });
})();

/* ---- Exhibition carousels ------------------------------------------
   Each [data-mc-carousel] holds a horizontal, scroll-snapping track of
   photos. The ‹ › buttons nudge it one photo at a time; on touch you just
   swipe. Tapping a photo still opens it large in the lightbox (handled
   above). No library, native scrolling, calm. */
(function () {
  var carousels = Array.prototype.slice.call(
    document.querySelectorAll('[data-mc-carousel]')
  );
  carousels.forEach(function (root) {
    var track = root.querySelector('[data-mc-carousel-track]');
    var prev = root.querySelector('[data-mc-carousel-prev]');
    var next = root.querySelector('[data-mc-carousel-next]');
    if (!track || !prev || !next) return;

    function step(dir) {
      var slide = track.querySelector('.mc-carousel__slide');
      var by = slide ? slide.getBoundingClientRect().width + 12 : track.clientWidth * 0.8;
      track.scrollBy({ left: dir * by, behavior: 'smooth' });
    }
    function sync() {
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max;
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(sync);
    }, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();

    // Always return to the first photo (the hero image) so it greets the
    // visitor on their way back, and reset auto-advance from the start.
    function toStart() { track.scrollTo({ left: 0, behavior: 'auto' }); }

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplayOn = root.getAttribute('data-mc-autoplay') === 'true' && !reduceMotion;
    var timer = null;

    function atEnd() {
      return track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }
    function tick() {
      if (atEnd()) toStart();
      else step(1);
    }
    function startAuto() {
      if (!autoplayOn || timer) return;
      timer = window.setInterval(tick, 5000);
    }
    function stopAuto() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    // Pause on interaction, resume when the pointer leaves.
    ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) {
      root.addEventListener(ev, stopAuto, { passive: true });
    });
    ['mouseleave', 'focusout'].forEach(function (ev) {
      root.addEventListener(ev, startAuto, { passive: true });
    });

    // Snap back to photo 1 when scrolled out of view; play only while visible.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            startAuto();
          } else {
            stopAuto();
            toStart();
            sync();
          }
        });
      }, { threshold: 0.2 });
      io.observe(root);
    } else {
      startAuto();
    }
  });
})();

/* ---- “View more” galleries -----------------------------------------
   Each [data-mc-reveal-scope] wraps exactly one gallery + its button.
   The gallery gets mc-reveal--active (enabling CSS to hide overflow photos);
   the button toggles is-open on that same gallery.
   Progressive: without JS every photo is visible (the hiding class only
   takes effect once JS marks the gallery active). */
(function () {
  var scopes = Array.prototype.slice.call(
    document.querySelectorAll('[data-mc-reveal-scope]')
  );
  scopes.forEach(function (scope) {
    var gallery = scope.querySelector('.mc-reveal--more');
    var btn = scope.querySelector('[data-mc-reveal-btn]');
    if (!gallery || !btn) return;
    gallery.classList.add('mc-reveal--active'); // now the CSS hides the overflow
    btn.addEventListener('click', function () {
      var open = gallery.classList.toggle('is-open');
      btn.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    btn.setAttribute('aria-expanded', 'false');
  });
})();

/* ---- Mahi gallery — tag filter -------------------------------------
   Filter buttons (built from each photo's tags) show only the matching
   photos. "All" restores everything. Progressive: without JS every photo
   stays visible. */
(function () {
  var bars = Array.prototype.slice.call(
    document.querySelectorAll('[data-mc-filter]')
  );
  bars.forEach(function (bar) {
    var section = bar.closest('.mc-mahi') || document;
    var pieces = Array.prototype.slice.call(section.querySelectorAll('.mc-piece'));
    var buttons = Array.prototype.slice.call(bar.querySelectorAll('[data-mc-filter-tag]'));

    function apply(tag) {
      var filtering = tag !== '';
      section.classList.toggle('is-filtered', filtering);
      pieces.forEach(function (p) {
        var tags = (p.getAttribute('data-mc-tags') || '').split(',').map(function (t) {
          return t.trim();
        });
        var match = !filtering || tags.indexOf(tag) !== -1;
        p.classList.toggle('mc-filter__hidden', !match);
      });
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        buttons.forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        apply(b.getAttribute('data-mc-filter-tag') || '');
      });
    });
  });
})();
